import { GeorefData } from '../../../../../../store/uploadStore';
import { PhotoCoords } from '../../../../../../types';

export const readGeoref = async (file: File): Promise<GeorefData['georef']> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        const parsed = parseGeoref(reader.result);
        if (!Object.values(reader.result).length) {
          reject(new Error("Failed to parse the file or it's empty"));
        }
        resolve(parsed);
      } else {
        reject(new Error('Failed to read georef as text'));
      }
    };

    reader.onerror = () => {
      reject(new Error(`Failed to read georef: ${reader.error?.message}`));
    };

    reader.readAsText(file);
  });
};

const parseGeoref = (input: string): GeorefData['georef'] => {
  const lines = input.trim().split('\n');
  const result: { [name: string]: PhotoCoords | undefined } = {};

  for (const line of lines) {
    const parts = line.split(/\s+/); // Split by whitespace
    if (parts.length >= 3) {
      const name = parts[0];
      const lon = parseFloat(parts[1]);
      const lat = parseFloat(parts[2]);

      if (!isNaN(lon) && !isNaN(lat)) {
        result[name] = [lon, lat];
      }
    }
  }

  return result;
};
